
export enum DbNamesEnum {
    SEPL_SCAN = "SEPL_Scan",
    PROFIT_DB = "ProFit_DB"
}
